import cx from "classnames";
import styles from "./index.module.scss";

export default ({ className, ...rest }) => (
  <svg
    {...rest}
    className={cx(styles.main, className)}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12Zm10-1.41L15.59 7 17 8.41 13.41 12 17 15.59 15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59Z"
      clip-rule="evenodd"
      fill-rule="evenodd"
    />
  </svg>
);
